import { Link } from './Brand.tsx';

/**
 * "Show on Live Now": public (listed while live) or unlisted (only people with the link). Can be
 * flipped before going live or mid-stream. Listing needs a signed-in account; guests stay unlisted.
 * `onSignIn` signs in on the page instead of going to /signin (the Go Live page: leaving it stops the stream).
 */
export function ListedSwitch({ listed, onChange, canList, busy = false, tone = 'light', onSignIn }: {
  listed: boolean;
  onChange: (listed: boolean) => void;
  canList: boolean;
  busy?: boolean;
  tone?: 'light' | 'dark';
  onSignIn?: () => void;
}) {
  const dark = tone === 'dark';
  return (
    <div className={`flex items-center justify-between gap-3 rounded-2xl px-4 py-3 ${dark ? 'bg-white/10' : 'bg-mist'}`}>
      <div className="min-w-0">
        <p className="font-extrabold">Show on Live Now</p>
        <p className={`text-[13px] ${dark ? 'text-muted-dark' : 'text-muted'}`}>
          {!canList ? (
            <>
              {onSignIn ? (
                <button type="button" onClick={onSignIn} className="font-bold underline">Sign in</button>
              ) : (
                <Link to="/signin" className="font-bold underline">Sign in</Link>
              )}{' '}
              to list your stream. Your link works either way.
            </>
          ) : listed ? (
            'Public: anyone can find it while you’re live.'
          ) : (
            'Unlisted: only people with your link.'
          )}
        </p>
      </div>
      <button
        type="button"
        role="switch"
        aria-checked={listed}
        aria-label="Show on Live Now"
        disabled={!canList || busy}
        onClick={() => onChange(!listed)}
        className={`relative h-8 w-14 shrink-0 rounded-full transition disabled:opacity-40 ${listed ? 'bg-race' : dark ? 'bg-white/25' : 'bg-line'}`}
      >
        <span className={`absolute top-1 h-6 w-6 rounded-full bg-white shadow transition-all ${listed ? 'left-7' : 'left-1'}`} />
      </button>
    </div>
  );
}
